import { inject, Injectable } from '@angular/core';
import { LiveDataService } from '../live-data.service';
import { Observable } from 'rxjs';
import { StationDataInterface } from '../../models/bff/station-data.interface';
import { PositionRequest } from '../../models/bff/position-request.interface';

const PATH_CHARGEPOINT = '/station-lookup/';
const PATH_NEARBY = '/stations/nearby';

@Injectable({
  providedIn: 'root',
})
export class StationApiService {
  public readonly http: LiveDataService = inject(LiveDataService);
  public getChargingStationInfo(chargerId: string): Observable<StationDataInterface> {
    return this.http.get(PATH_CHARGEPOINT + chargerId);
  }

  public getNearbyStations(position: PositionRequest): Observable<StationDataInterface[]> {
    return this.http.post(PATH_NEARBY, position);
  }
}
